<template>
  <spinner v-if="loading" />
  <div v-else class="screen-container">
    <v-layout column>
      <v-flex class="title-screen" xs12>
        <span>{{ adminText('workflowsAll.tickets_5c622a5', 'Tickets') }}</span>
      </v-flex>
      <v-flex x4>
        <div class="title-description attendee-table-description" />
      </v-flex>
      <v-flex class="mb-16 desktop-button">
        <v-toolbar-items v-if="event.extraModules.floorPlan">
          <v-menu v-model="ticketMenu" offset-y nudge-bottom="4">
            <main-button slot="activator" style="padding: 10px 20px">
              <v-icon class="material-icons" color="white"> add</v-icon>
              <span style="color: white; margin: 0 12px"> {{ adminText('workflowsAll.new_ticket_b8bf9c8', 'New ticket') }} </span>
              <v-icon class="material-icons" color="white"> expand_more</v-icon>
            </main-button>
            <v-list
              v-for="(item, index) in ticketTypeData"
              :key="index"
              style="padding: 0"
              class="menu"
            >
              <div class="ticket-container" @click="onCreateTicketFloorPlanClick(item)">
                <img :src="require(`../../../public/assets/${item.svg}`)" :alt="workflowTicketTypeLabel(item.type)">
                <span class="ticket-type">{{ workflowTicketTypeLabel(item.type) }}</span>
              </div>
            </v-list>
          </v-menu>
          <main-button outline class="gratis-button" @click="onCreateGratisTicketClick()">
            <img class="gratis-ticket-icon" src="/assets/free-ticket.svg" :alt="adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket')">
            {{ adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket') }}
            <v-icon style="margin-left: 8px">arrow_forward</v-icon>
          </main-button>
        </v-toolbar-items>
        <div v-else>
          <main-button depressed @click="onCreateTicketClick">
            <span class="add-symbol">+</span>{{ adminText('workflowsAll.create_ticket_3afcbed', 'Create ticket') }}
          </main-button>
          <main-button outline @click="onCreateGratisTicketClick()">
            <img class="gratis-ticket-icon" src="/assets/free-ticket.svg" :alt="adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket')">
            {{ adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket') }}
          </main-button>
          <main-button
            :text="adminText('workflowsAll.event_s_max_capacity_a03d189', 'Event\'s max capacity')"
            flat
            class="max-capacity-button"
            @click="isEventMaxCapacityModalOpen = !isEventMaxCapacityModalOpen"
          />
        </div>
      </v-flex>
      <div v-if="!$apollo.loading" class="attendee_table">
        <selected-items-header
          v-if="selected.length"
          :selected="selected"
          name="ticket"
          @clear="selected = []"
          @delete="showDeleteDialog = true"
        />
        <div
          v-if="tickets.length === 0"
          class="no-attendees-message-container border__left border__right"
        >
          <span class="no-attendees-message">{{ adminText('workflowsAll.no_matching_records_found_0c7f0a6', 'No matching records found.') }}</span>
        </div>
        <table-list
          v-else
          :hide-checkbox="true"
          :show-toggle-button="true"
          :event-id="eventId"
          :organization-slug="organizationSlug"
          :selected.sync="selected"
          :attendees="tickets"
          body-style="grid-auto-columns: 128px minmax(150px, 372px) !important;"
          :visible-fields="visibleFields"
          :attendee-fields="attendeeFields"
          :pagination="pagination"
          @click="
            goTo(
              isRegularOrganization()
                ? routes.organizer.editTicket
                : routes.sportOrganizer.editTicketSport,
              { eventId: eventId, ticketId: $event },
            )
          "
          @sort="handleSort($event)"
          @orderDelete="
            ;(ticketDeleteId = $event),
              (ticketDeleteExists = true),
              canBeDeletedHandler(ticketDeleteId)
          "
          @updateTicketActivity="updateTicketActivity"
        />
        <table-pagination
          :pagination="pagination"
          :total-attendees="totalTicketCount"
          @change="handlePagination($event)"
          @changePerPage="handlePagination($event)"
        />
      </div>
    </v-layout>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_tick_15cbb98', 'Are you sure you want to delete selected tickets? This operation cannot be undone.')))"
      :on-delete="deleteSelected"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.delete_tickets_aefe642', 'Delete tickets')"
    />
    <div v-if="ticketDeleteExists && ticketCanBeDeleted" class="delete-wrapper">
      <div class="delete-container">
        <div class="delete-header">
          <h1 class="delete-title">{{ adminText('workflowsAll.are_you_sure_you_want_to_delete_this_ticket_t_e7236e0', 'Are you sure you want to delete this ticket type?') }}</h1>
          <img
            :alt="adminText('workflowsAll.close_window_e3896a9', 'Close window')"
            src="/assets/close-icon.svg"
            class="close-icon-style"
            @click="ticketDeleteExists = !ticketDeleteExists"
          >
        </div>
        <p class="delete-description">
          {{ adminText('workflowsAll.users_will_not_be_able_to_see_or_buy_this_tic_4b25906', 'Users will not be able to see or buy this ticket type and all the data will be lost. If you just want to hide this ticket type, you can change the visibility setting in the edit section. If you still want to proceed, this action cannot be undone.') }}
        </p>
        <div class="delete-buttons">
          <main-button
            :text="adminText('workflowsAll.edit_ticket_fa35ddb', 'Edit ticket')"
            outline
            @click="
              goTo(
                isRegularOrganization()
                  ? routes.organizer.editTicket
                  : routes.sportOrganizer.editTicketSport,
                { eventId: eventId, ticketId: ticketDeleteId },
              )
            "
          />
          <main-button
            :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')"
            color="#DB384C"
            @click="deleteTicket(), (ticketDeleteExists = !ticketDeleteExists)"
          />
        </div>
      </div>
    </div>
    <section v-if="event.extraModules.floorPlan" class="sales-channel-settings">
      <div class="sales-channel-settings__intro">
        <div class="sales-channel-settings__icon" aria-hidden="true">
          <v-icon color="#0277bd" size="20">storefront</v-icon>
        </div>
        <div>
          <h2>{{ adminText('workflowsAll.sales_channels_07c6da3', 'Sales channels') }}</h2>
          <p>{{ adminText('workflowsAll.choose_where_attendees_can_purchase_tickets_f_1980067', 'Choose where attendees can purchase tickets for this event.') }}</p>
        </div>
      </div>

      <div class="sales-channel-settings__content">
        <p v-if="!tickets.length" class="sales-channel-settings__notice">
          {{ adminText('workflowsAll.create_at_least_one_ticket_before_selecting_a_534e4ad', 'Create at least one ticket before selecting a sales channel.') }}
        </p>

        <div class="sales-channel-settings__fields">
          <select-field
            v-model="selectedSalesChannel"
            :disabled="!tickets.length"
            :items="localizedSalesChannels"
            item-render="caption"
            item-select="value"
            :label="adminText('workflowsAll.sales_channel_2ec4e30', 'Sales channel')"
            class="sales-channel-settings__channel"
          />
          <div
            v-if="selectedSalesChannel === SalesChannels.SPECIFIC_OUTLETS"
            class="sales-channel-settings__outlet-stack"
          >
            <v-menu
              v-model="outletsMenu"
              class="sales-channel-settings__outlets-menu"
              offset-y
              :close-on-content-click="false"
              max-height="320"
            >
              <button slot="activator" type="button" class="sales-channel-settings__outlets">
                <span class="sales-channel-settings__outlets-label">{{ adminText('workflowsAll.select_outlets_f829de6', 'Select outlets') }}</span>
                <span class="sales-channel-settings__selection-summary" :title="workflowLabel(selectedOutletsLabel)">
                  {{ workflowLabel(selectedOutletsLabel || adminText('workflowsAll.select_outlets_f829de6', 'Select outlets')) }}
                </span>
                <v-icon class="sales-channel-settings__outlets-icon" size="22">arrow_drop_down</v-icon>
              </button>
              <v-list dense>
                <v-list-tile
                  v-for="seller in availableSellers"
                  :key="seller.id"
                  @click="toggleSeller(seller.id)"
                >
                  <v-list-tile-action>
                    <v-icon :color="isSellerSelected(seller.id) ? '#0277bd' : '#979797'">
                      {{ isSellerSelected(seller.id) ? 'check_box' : 'check_box_outline_blank' }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ workflowLabel(seller.name) }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
            <p
              v-if="form.sellers.length && tisak && form.sellers.includes(tisak.id)"
              class="sales-channel-settings__warning"
            >
              <v-icon size="16" color="#0277bd">mdi-information-outline</v-icon>
              {{ adminText('workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_4f02543', 'TISAK outlets will charge ticket buyers an additional ticket fee.') }}
            </p>
          </div>
        </div>

        <p
          v-if="selectedSalesChannel === SalesChannels.ALL_OUTLETS"
          class="sales-channel-settings__warning"
        >
          <v-icon size="16" color="#0277bd">mdi-information-outline</v-icon>
          {{ adminText('workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_4f02543', 'TISAK outlets will charge ticket buyers an additional ticket fee.') }}
        </p>

        <div class="sales-channel-settings__actions">
          <main-button
            class="sales-channel-settings__save"
            :disabled="!canUpdateSaleChannel"
            :text="adminText('workflowsAll.save_sales_channels_0171ad1', 'Save sales channels')"
            @click="updateSalesChannels()"
          />
        </div>
      </div>
    </section>
    <div class="mobile-ticket-actions hide">
      <main-button
        v-if="!event.extraModules.floorPlan"
        depressed
        :disabled="!user.isVerifiedByCoreEvent"
        :text="adminText('workflowsAll.create_ticket_afe9a7a', 'Create Ticket')"
        @click="onCreateTicketClick"
      />
      <v-menu v-else v-model="ticketMenu" offset-y nudge-bottom="4">
        <main-button slot="activator" style="padding: 10px 20px">
          <v-icon class="material-icons" color="white"> add</v-icon>
          <span style="color: white; margin: 0 12px"> {{ adminText('workflowsAll.new_ticket_b8bf9c8', 'New ticket') }} </span>
          <v-icon class="material-icons" color="white"> expand_more</v-icon>
        </main-button>
        <v-list
          v-for="(item, index) in ticketTypeData"
          :key="index"
          style="padding: 0"
          class="menu-mobile"
        >
          <div class="ticket-container" @click="onCreateTicketFloorPlanClick(item)">
            <img :src="require(`../../../public/assets/${item.svg}`)" :alt="workflowTicketTypeLabel(item.type)">
            <span class="ticket-type">{{ workflowTicketTypeLabel(item.type) }}</span>
          </div>
        </v-list>
      </v-menu>
      <main-button
        outline
        class="gratis-mobile-button"
        :text="adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket')"
        @click="onCreateGratisTicketClick"
      />
    </div>
    <div v-if="ticketDeleteExists && !ticketCanBeDeleted" class="delete-wrapper">
      <div class="delete-container">
        <div class="delete-header">
          <h1 class="delete-title">{{ adminText('workflowsAll.this_ticket_type_cannot_be_deleted_41b425f', 'This ticket type cannot be deleted') }}</h1>
          <img
            :alt="adminText('workflowsAll.close_window_e3896a9', 'Close window')"
            src="/assets/close-icon.svg"
            class="close-icon-style"
            @click="ticketDeleteExists = !ticketDeleteExists"
          >
        </div>
        <p class="delete-description">
          {{ adminText('workflowsAll.there_are_purchases_containing_this_ticket_ty_863bae0', 'There are purchases containing this ticket type. If you want users to not be able to see or buy this ticket type, you can change the visibility setting in the edit section.') }}
        </p>
        <div class="delete-buttons">
          <main-button
            depressed
            :text="adminText('workflowsAll.edit_ticket_fa35ddb', 'Edit ticket')"
            @click="
              goTo(
                isRegularOrganization()
                  ? routes.organizer.editTicket
                  : routes.sportOrganizer.editTicketSport,
                { eventId: eventId, ticketId: ticketDeleteId },
              )
            "
          />
        </div>
      </div>
    </div>
    <simple-snackbar
      :open.sync="snackbarOpen"
      :message-prop="adminText('workflowsAll.sales_channels_save_successfully_b9c2cd1', 'Sales channels save successfully.')"
      color="primary"
    />
    <simple-snackbar :open.sync="maxTicketsErrorSnackBar.open" :message-prop="workflowLabel(maxTicketsErrorSnackBar.messageProp)" :color="maxTicketsErrorSnackBar.color" />
    <simple-snackbar :open.sync="salesStatusSnackbar.open" :message-prop="workflowLabel(salesStatusSnackbar.messageProp)" :color="salesStatusSnackbar.color" />
    <event-max-capacity-modal
      v-if="isEventMaxCapacityModalOpen"
      :audience-capacity="event.audienceCapacity"
      @close="isEventMaxCapacityModalOpen = false"
      @updateMaxCapacity="updateMaxCapacity"
    />
    <demo-modal v-if="demoModal" :user="user" @close="demoModal = false" />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import EventMaxCapacityModal from '@/components/tickets/event-max-capacity-modal.vue'
import { GET_EVENT_DETAILS, SET_MAX_TICKETS_NUMBER } from '@/graphql/event.graphql'
import {
  CHANGE_TICKET_VALIDITY_DATES,
  DELETE_ORDER_ITEM,
  DELETE_ORDER_ITEMS,
  GET_ORDER_ITEMS,
  UPDATE_SALES_CHANNELS,
} from '@/graphql/orderItem.graphql'
import { GET_TICKET_SELLERS } from '@/graphql/user.graphql'
import { OrganizationType, SalesChannels, TicketSellerOrganizationType, TicketType } from '@/types'
import { tisakTicketSeller } from '@/utils'
import TableList from '../accreditations/attendee-table/list.vue'
import TablePagination from '../accreditations/attendee-table/pagination.vue'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import SelectedItemsHeader from './selected-items-header'
import DemoModal from '@/components/organizations/DemoModal.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'tickets-list',
  components: {
    DemoModal,
    EventMaxCapacityModal,
    TableList,
    TablePagination,
    SelectedItemsHeader,
    DeleteDialog,
    SimpleSnackbar,
  },
  props: {
    eventId: String,
    user: Object,
    organizationSlug: String,
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      attendees: [],
      totalTicketCount: 0,
      categories: [],
      attendeeFields: {},
      snackbarOpen: false,
      demoModal: false,
      visibleFields: [
        'Ticket name',
        'Ticket category',
        'Quantity',
        'Price',
        'Start date',
        'End date',
        // 'Sales channel',
      ],
      ticketTypeData: [
        {
          type: 'STANDING TICKET',
          svg: 'Stand.svg',
          linkParams: function () {
            return this.handleOpenTicketModal('parter', true)
          }.bind(this),
        },
        {
          type: 'SEATING TICKET',
          svg: 'Seat.svg',
          linkParams: function () {
            return this.handleOpenTicketModal()
          }.bind(this),
        },
        {
          type: 'TABLE TICKET',
          svg: 'Table.svg',
          linkParams: function () {
            return this.handleOpenTicketModal('table', false, true)
          }.bind(this),
        },
      ],
      eventAttendeeFields: {},
      selected: [],
      pagination,
      tisak: {},
      SalesChannels,
      form: { sellers: [] },
      ticketMenu: false,
      outletsMenu: false,
      initialSalesChannels: SalesChannels.ONLINE,
      salesChannels: Object.values(SalesChannels),
      selectedSalesChannel: SalesChannels.ONLINE,
      availableSellers: [],
      snackbar: false,
      showDeleteDialog: false,
      event: { extraModules: { floorPlan: false } },
      paginationLoading: false,
      tickets: [],
      loading: true,
      ticketDeleteId: 0,
      ticketDeleteExists: false,
      ticketCanBeDeleted: false,
      isEventMaxCapacityModalOpen: false,
      maxTicketsErrorSnackBar: {},
      salesStatusSnackbar: {},
    }
  },
  apollo: {
    getEventBySlug: {
      query: GET_EVENT_DETAILS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const { getEvent: event } = data
          this.event = event
          if (event.venueId) {
            this.visibleFields.splice(1, 0, 'Type')
          }
          this.filterSportPrepaidCouponTickets()
        }
      },
    },
    getOrderItems: {
      query: GET_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.eventId,
          status: 'ALLOWED',
          pagination: this.pagination,
          isGratis: false,
        }
      },
      manual: true,
      async result({ data, loading }) {
        if (!loading) {
          const {
            data: { getTicketSellers },
          } = await this.$apollo.query({ query: GET_TICKET_SELLERS })
          const allTicketSellers = getTicketSellers.filter(
            ts => ts.type !== TicketSellerOrganizationType.THEATER,
          )
          this.availableSellers = allTicketSellers
          if (this.organizationSlug !== 'kk-cibona-ba9e') {
            this.availableSellers = this.availableSellers.filter(seller => seller.id !== '33')
          }
          this.tisak = allTicketSellers.find(u => u.name.toLowerCase() === tisakTicketSeller)
          this.tickets = this.mapTickets(data.getOrderItems.items)
          this.setVisibleFields(data)
          this.totalTicketCount = data.getOrderItems.totalCount
          this.loading = false
          this.filterSportPrepaidCouponTickets()
        }
      },
    },
  },
  computed: {
    localizedSalesChannels() { return this.salesChannels.map(value => ({ value, caption: this.workflowSalesChannelOption(value) })) },
    canUpdateSaleChannel() {
      const atLeastOneTicket = !!this.tickets.length
      const channelChangedAndHasSelectedSellers =
        this.selectedSalesChannel === this.SalesChannels.SPECIFIC_OUTLETS &&
        this.form.sellers.length === 0

      return atLeastOneTicket && !channelChangedAndHasSelectedSellers
    },
    selectedOutletsLabel() {
      const selectedOutletIds = this.form.sellers.map(id => String(id))

      return this.availableSellers
        .filter(seller => selectedOutletIds.includes(String(seller.id)))
        .map(seller => seller.name)
        .join(', ')
    },
  },
  methods: {
    setVisibleFields(data) {
      if (
        data.getOrderItems.items.length &&
        data.getOrderItems.items[0].event.extraModules.floorPlan
      ) {
        this.visibleFields = this.visibleFields.filter(field => field !== 'Quantity')
      }

      if (
        data.getOrderItems.items.length &&
        !data.getOrderItems.items[0].event.extraModules.floorPlan
      ) {
        this.visibleFields.push('W/ access code')
      }
    },
    mapTickets(tickets) {
      return tickets.map(ticket => {
        let type = null
        if (ticket.itemMeta.table) {
          type = 'Table'
        } else if (ticket.itemMeta.parter) {
          type = 'Parter'
        } else {
          type = 'Seat'
        }
        const fromDate = new Date(ticket.from)
        const toDate = new Date(ticket.to)

        const yeFrom = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(fromDate)
        const moFrom = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(fromDate)
        const daFrom = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(fromDate)

        const yeTo = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(toDate)
        const moTo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(toDate)
        const daTo = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(toDate)

        let ticketSellersLabel = ''
        if (ticket.ticketSellerOrganizations.length === 0) {
          ticketSellersLabel = this.SalesChannels.ONLINE
        } else if (ticket.ticketSellerOrganizations.length < this.availableSellers.length) {
          ticketSellersLabel = _.first(ticket.ticketSellerOrganizations.map(s => s.name))
          this.form.sellers = ticket.ticketSellerOrganizations.map(s => s.id)
          this.selectedSalesChannel = this.SalesChannels.SPECIFIC_OUTLETS
          this.initialSalesChannels = this.SalesChannels.SPECIFIC_OUTLETS
          this.salesChannels = this.salesChannels.filter(
            channel => channel !== this.SalesChannels.ONLINE,
          )
        } else if (ticket.ticketSellerOrganizations.length === this.availableSellers.length) {
          this.form.sellers = this.availableSellers.map(s => s.id)
          ticketSellersLabel = this.SalesChannels.ALL_OUTLETS
          this.selectedSalesChannel = this.SalesChannels.ALL_OUTLETS
          this.initialSalesChannels = this.SalesChannels.ALL_OUTLETS
          this.salesChannels = this.salesChannels.filter(
            channel => channel !== this.SalesChannels.ONLINE,
          )
        } else {
          ticketSellersLabel = `${ticket.ticketSellerOrganizations.length} outlets`
        }

        return {
          ...ticket,
          ticketSellersLabel,
          isSoldOut: ticket.quantity == ticket.initialQuantity,
          quantity: `${ticket.quantity}`,
          from: `${daFrom}.${moFrom}.${yeFrom}`,
          to: `${daTo}.${moTo}.${yeTo}`,
          type,
          adminTicketRow: true,
          fullDateFrom: ticket.from,
          fullDateTo: ticket.to,
          accessCode:
            ticket.itemMeta && ticket.itemMeta.accessCode ? ticket.itemMeta.accessCode : '',
        }
      })
    },
    handleOpenTicketModal(type = 'regular') {
      this.goTo(
        this.isRegularOrganization()
          ? this.routes.organizer.createTicket
          : this.routes.sportOrganizer.createTicketSport,
        {
          eventId: this.eventId,
          user: this.user,
          type,
        },
      )
    },
    handleOpenGratisTicketModal() {
      this.goTo(
        this.isRegularOrganization()
          ? this.routes.organizer.gratisTickets
          : this.routes.sportOrganizer.gratisTicketsSport,
        {
          eventId: this.eventId,
          user: this.user,
          organizationSlug: this.organizationSlug,
        },
      )
    },
    async updateSalesChannels() {
      let salesChannels = []
      let changeInitialSalesChannels = this.SalesChannels.ONLINE
      if (this.selectedSalesChannel === this.SalesChannels.SPECIFIC_OUTLETS) {
        salesChannels = this.form.sellers
        changeInitialSalesChannels = this.SalesChannels.SPECIFIC_OUTLETS
      } else if (this.selectedSalesChannel === this.SalesChannels.ALL_OUTLETS) {
        changeInitialSalesChannels = this.SalesChannels.ALL_OUTLETS
        salesChannels = this.availableSellers.map(seller => seller.id)
      }

      const { data, error } = await this.$apollo.mutate({
        mutation: UPDATE_SALES_CHANNELS,
        variables: {
          eventId: this.eventId,
          salesChannels: salesChannels,
        },
      })
      if (!error) {
        this.initialSalesChannels = changeInitialSalesChannels
        this.snackbarOpen = true
        if (this.initialSalesChannels === this.SalesChannels.ONLINE) {
          this.form.sellers = []
        }
      }
      await this.$apollo.queries.getOrderItems.refetch()
    },
    deselectSeller(item) {
      this.form.sellers = this.form.sellers.filter(sellerId => sellerId !== item.id)
    },
    isSellerSelected(sellerId) {
      return this.form.sellers.some(selectedId => String(selectedId) === String(sellerId))
    },
    toggleSeller(sellerId) {
      if (this.isSellerSelected(sellerId)) {
        this.form.sellers = this.form.sellers.filter(
          selectedId => String(selectedId) !== String(sellerId),
        )
      } else {
        this.form.sellers = [...this.form.sellers, sellerId]
      }
    },
    canBeDeletedHandler(ticketId) {
      const ticket = this.tickets.find(t => t.id == ticketId)
      this.ticketCanBeDeleted = ticket.isSoldOut

      return
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalTicketCount - currentPerPage * currentPage > 0)) return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      this.addPaginationToRoute(this.pagination)

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 25,
          sortBy: sortBy,
          descending: descending === 'true' ? true : false,
        },
      }
    },
    addPaginationToRoute({ page, per_page, sortBy, descending }) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending,
        },
      })
    },
    async deleteTicket() {
      await this.$apollo.mutate({
        mutation: DELETE_ORDER_ITEM,
        variables: {
          orderItemId: this.ticketDeleteId,
        },
      })

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async deleteSelected() {
      await this.$apollo.mutate({
        mutation: DELETE_ORDER_ITEMS,
        variables: {
          orderItemIds: this.selected,
        },
      })

      this.selected = []
      await this.$apollo.queries.getOrderItems.refetch()
    },
    async updateTicketActivity(ticketId, validity) {
      const { errors } = await this.$apollo.mutate({
        mutation: CHANGE_TICKET_VALIDITY_DATES,
        variables: { organizationSlug: this.organizationSlug, orderItemId: ticketId, validity },
      })

      if (errors) {
        this.salesStatusSnackbar = {
          open: true,
          messageProp: errors[0].message,
          color: 'error',
        }

        return
      }

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async updateMaxCapacity(maxCapacityValue) {
      const { errors } = await this.$apollo.mutate({
        mutation: SET_MAX_TICKETS_NUMBER,
        variables: {
          eventId: this.eventId,
          maxTickets: maxCapacityValue === null ? null : Number(maxCapacityValue),
        },
      })

      if (errors) {
        this.maxTicketsErrorSnackBar = {
          open: true,
          messageProp: errors[0].message,
          color: 'error',
        }

        return
      }

      this.isEventMaxCapacityModalOpen = false
      this.maxTicketsErrorSnackBar = {
        open: true,
        messageProp: 'workflowsAll.event_s_max_capacity_successfully_updated_8946ee0',
        color: 'primary',
      }
      await this.$apollo.queries.getEventBySlug.refetch()
    },

    isRegularOrganization() {
      return this.$route.path.includes('/organizations/')
    },

    filterSportPrepaidCouponTickets() {
      if (
        !this.event.organization ||
        this.loading ||
        this.event.organization.type !== OrganizationType.SPORT_ORGANIZATION
      )
        return

      this.tickets = this.tickets.filter(ticket => !ticket.prepaidCoupon)
    },
    onCreateGratisTicketClick() {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        this.handleOpenGratisTicketModal()
      }
    },
    onCreateTicketClick() {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        this.goTo(
          this.isRegularOrganization()
            ? this.routes.organizer.createTicket
            : this.routes.sportOrganizer.createTicketSport,
          { eventId: this.eventId, user: this.user, type: TicketType.REGULAR },
        )
      }
    },
    onCreateTicketFloorPlanClick(item) {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        return item.linkParams()
      }
    },
  },
}
</script>

<style scoped>
.attendee-table-description {
  max-width: 900px;
  margin-bottom: 28px;
}

.no-attendees-message-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-attendees-message {
  color: #979797;
  padding: 20px;
}

.border__left {
  border-left: 2px solid #f5f5f5;
}

.border__right {
  border-right: 2px solid #f5f5f5;
}

ul {
  list-style-type: none;
}

.err-line {
  margin-bottom: 8px;
}

.err-line span {
  font-weight: bold;
}

.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.gratis-ticket-icon {
  margin-right: 0.5rem;
}

.gratis-mobile-button {
  margin-top: 0;
}

.gratis-button {
  margin-left: 1rem !important;
  height: 3rem;
  padding: 0.625rem 1.25rem;
}

.menu-mobile {
  display: none !important;
}

@media screen and (max-width: 800px) {
  .menu {
    display: none !important;
  }

  .menu-mobile {
    display: block !important;
  }

  .gratis-mobile-button {
    background-color: white !important;
  }

  .mobile-ticket-actions {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    margin-top: 1rem;
  }

  .mobile-ticket-actions > *,
  .mobile-ticket-actions >>> .v-menu__activator,
  .mobile-ticket-actions >>> .main-button {
    display: block;
    width: 100%;
    margin: 0 !important;
  }

  .mobile-ticket-actions >>> .v-btn {
    height: 3rem;
    min-height: 3rem;
    padding: 0 0.75rem;
    box-shadow: 0 4px 16px rgba(51, 51, 51, 0.16) !important;
  }

  .title-screen {
    display: none;
  }

  .screen-container {
    margin-top: 0;
  }

  .attendee_table {
    margin-top: 1rem;
  }

}

.add-symbol {
  font-size: 1.875rem;
  margin-right: 0.8125rem;
  font-weight: 200;
}

.delete-message {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: white;
  opacity: 80%;
  z-index: 500;
}

.delete-wrapper {
  background-color: rgba(0, 0, 0, 0.8);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  content: '';
  position: fixed;
}

.delete-wrapper > .delete-container {
  width: 43.75rem;
  background: white;
  position: fixed;
  max-width: 80%;
  opacity: none;
  text-align: left;
  border-radius: 0.5rem;
  top: 25%;
  left: 50%;
  filter: drop-shadow(0px 0px 24px rgba(51, 51, 51, 0.2));
  padding: 1.25rem;
  transform: translate(-50%, 0);
}

.delete-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -0.03em;
  color: #0277bd;
  margin-bottom: 1.5rem;
}

.delete-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #666666;
}

.delete-buttons {
  display: flex;
  justify-content: flex-end;
}

.ticket-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.ticket-container:hover {
  background: #cee4f2;
}

.delete-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.close-icon-style:hover {
  cursor: pointer;
}

.ticket-type {
  color: var(--Primary-10, #0277bd);
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  /* Button/Large */
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */
  letter-spacing: -0.27px;
  text-transform: uppercase;
}

.sales-channel-settings {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  margin-top: 2rem;
  padding: 1.5rem;
  border: 1px solid #e1e9ee;
  border-radius: 10px;
  background: #ffffff;
}

.sales-channel-settings__intro {
  display: flex;
  flex: 0 0 15rem;
  align-items: flex-start;
  gap: 0.75rem;
  padding-top: 0.25rem;
}

.sales-channel-settings__icon {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 6px;
  background: #e6f1f8;
}

.sales-channel-settings__intro h2 {
  margin: 0 0 0.375rem;
  color: #333333;
  font-family: Raleway, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.3;
}

.sales-channel-settings__intro p,
.sales-channel-settings__notice,
.sales-channel-settings__warning {
  margin: 0;
  color: #666666;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  line-height: 1.45;
}

.sales-channel-settings__content {
  flex: 1 1 auto;
  min-width: 0;
}

.sales-channel-settings__notice {
  margin-bottom: 1rem;
  padding: 0.625rem 0.75rem;
  border-left: 3px solid #8ec3e5;
  background: #eff7fb;
}

.sales-channel-settings__fields {
  display: grid;
  grid-template-columns: minmax(12rem, 0.8fr) minmax(0, 2.2fr);
  align-items: start;
  gap: 1.25rem;
}

.sales-channel-settings__outlet-stack {
  width: 100%;
}

.sales-channel-settings__outlets-menu {
  display: block;
  width: 100%;
}

.sales-channel-settings__channel {
  width: 100%;
  min-width: 0;
}

.sales-channel-settings__outlets {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  box-sizing: border-box;
  height: 64px;
  padding: 0.5rem 2.75rem 0.5rem 0.75rem;
  overflow: hidden;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
}

.sales-channel-settings__outlets:hover,
.sales-channel-settings__outlets:focus {
  border-color: #0277bd;
  outline: none;
}

.sales-channel-settings__outlets-label {
  position: absolute;
  top: 0.625rem;
  left: 0.75rem;
  color: #757575;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.75rem;
  line-height: 1;
}

.sales-channel-settings__selection-summary {
  display: block;
  min-width: 0;
  overflow: hidden;
  color: #0277bd;
  font-size: 0.9375rem;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-channel-settings__outlets-icon {
  position: absolute;
  top: 1.3rem;
  right: 0.625rem;
  color: #666666;
}

.sales-channel-settings__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1.25rem;
}

.sales-channel-settings__warning {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.625rem;
  padding: 0.5rem 0.625rem;
  border-left: 3px solid #8ec3e5;
  border-radius: 3px;
  background: #f0f7fb;
  color: #4d6878;
  font-size: 0.875rem;
  line-height: 1.35;
}

.sales-channel-settings__save {
  flex: 0 0 auto;
  min-height: 3rem;
  margin: 0 !important;
}

@media screen and (max-width: 800px) {
  .sales-channel-settings {
    flex-direction: column;
    gap: 1.25rem;
    margin-top: 1.5rem;
    padding: 1rem;
  }

  .sales-channel-settings__intro {
    flex-basis: auto;
  }

  .sales-channel-settings__fields {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .sales-channel-settings__save {
    width: 100%;
    margin: 0 !important;
  }
}

.max-capacity-button {
  float: right;
}
</style>
